<button name="scroll" aria-label="اسکرول" type="button" (click)="scroll()" @fadeIn class="badge-app-toTop" *ngIf="showUpButton">
  <i class="ie-icon ie-chevron up self-center"></i>
</button>
